<template>
	<div class="mainForm parceiros">
        <div class="voltar w-3/3">
            <router-link :to="{name: 'parcerias-list'}">
                <vs-button class="float-right mt-2" color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left">{{$t('returnButton')}}</vs-button>
            </router-link>
        </div>
		<div class="mt50">
			<div class="mt15">
				<vx-card>

					<vs-row vs-w="12">
					    
                        <vs-tabs alignment="fixed">
                            <vs-tab v-for="(lang, index) in langs" :key="index" :label="index">
                                
                                <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder inputNews">
                                        <div class="vx-col w-full">
                                            <vs-input class="w-full" label-placeholder="Parceiro" v-model="langs[index].partner" />
                                        </div>
                                    </div>

                                    <quill-editor v-model="langs[index].description" :options="editorOption" class="editorSpace desc_textarea">
                                        <div id="toolbar" slot="toolbar">
                                        </div>
                                    </quill-editor>

                                    <div class="w-full lspace giveSpaceContent">
                                        <vs-button class="mt-5 mb20" v-on:click="addFiles('files_file', index)" color="primary" type="filled" icon-pack="feather" icon="icon-image" v-if="langs[index].files.length < 3">Ficheiros</vs-button>

                                        <div class="pb60" v-if="langs[index].files.length > 0">
                                            <div v-for="(file, key) in langs[index].files" :key="key">
                                                <vs-chip @click="removeFile('files_file', index, key)" closable color="primary" close-icon="close">
                                                    <vs-avatar color="primary" icon-pack="feather" icon="icon-file-text" @click="popupS('doc', file.file_path, file.name, index, key)" />
                                                    <!-- {{ (parcerias_form.logo_path == null) ? file.files[0]['name'] : (/.*\/(.*)/.exec(parcerias_form.logo_path)[1]) }} -->
                                                    {{ file.name }}
                                                </vs-chip>
                                            </div>
                                        </div>
                                        <div class="hidden sm:hidden md:hidden lg:hidden">
                                            <label>
                                                <input type="file" :ref="'files_file_'+index" v-on:change="handleFileUploads('files_file', index)"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="w-full boxVisible">
                                        <vs-checkbox v-model="langs[index]['visible']">Visível</vs-checkbox>
                                    </div>
                                    
                                </vs-col>

                            </vs-tab>
                        </vs-tabs>

                        <vs-divider class="mb-5 mt-5" border-style="dashed"/>

                        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                            <div class="w-full">
                                <small class="block">Categoria</small>
                                <v-select class="vue-select sm:w-full lg:w-1/3 mb15" :clearable="false" :searchable="false" v-model="parcerias_form.category" :options="categories" label="name">
                                </v-select>
                            </div>
                        </vs-col>
                        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                            <div class="w-full">
                                <small class="block">Zonas</small>
                                <v-select class="vue-select sm:w-full lg:w-1/3 mb15" :multiple="true" :clearable="false" :searchable="false" v-model="parcerias_form.locals" :options="locals" label="name" placeholder="Todas">
                                </v-select>
                            </div>
                        </vs-col>
                        <vs-col class="w-full lspace giveSpaceContent">
                            <vs-button class="mt-5 mb20" v-on:click="addFiles('image_file', null)" color="primary" type="filled" icon-pack="feather" icon="icon-image" v-if="file.length == 0 && parcerias_form.logo_path == null">Logotipo</vs-button>

                            <div class="pb60" v-if="file.length > 0 || parcerias_form.logo_path != null">
                                <vs-chip @click="removeFile('image_file', null, null)" closable color="primary" close-icon="close">
                                    <vs-avatar :src="(parcerias_form.logo_path == null) ? generateImgPath(file[0]) : parcerias_form.logo_full_path" @click="popupS('img', parcerias_form.logo_full_path, parcerias_form.logo_path)" text="Logotipo"/>
                                    {{ (parcerias_form.logo_path == null) ? file[0]['name'] : (/.*\/(.*)/.exec(parcerias_form.logo_path)[1]) }}
                                </vs-chip>
                            </div>
                            <div class="hidden sm:hidden md:hidden lg:hidden">
                                <label>
                                    <input type="file" id="fileImg" ref="image_file" v-on:change="handleFileUploads('image_file', null)"/>
                                </label>
                            </div>
                        </vs-col>
                        <div class="datasLimiteDiv" :style="(parcerias_form['expiration_date'] == null) ? 'margin-bottom:28px' : ''">
                            <vs-col vs-w="4" vs-xs="12" >
                                <datepicker :disabledDates="disabledDatesValidade"  v-model="parcerias_form['expiration_date']" placeholder="Data de Validade" format="dd/MM/yyyy"></datepicker>
                                <feather-icon @click="clearDate('expiration_date')" v-if="parcerias_form['expiration_date'] != null" icon="XIcon" class="cursor-pointer r30"></feather-icon>
                            </vs-col>
                        </div>
                        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                            <div class="w-full mt-5 mb-5">
                                <div class="lg:w-1/4 sm:w-1/2 md:w-1/2">
                                    <vs-checkbox v-model="parcerias_form.visible">Visível</vs-checkbox>
                                </div>
                            </div>
                        </vs-col>

				    </vs-row>
				</vx-card>
			</div>

    		<div class="w-full">
	            <vs-button v-on:click="submitPartner()" class="mt-3" color="primary" type="filled" icon-pack="feather" icon="icon-save">Guardar</vs-button>
	        </div>

            <vs-popup :title="popupShow.title" :active.sync="popupShow.show" class="wPopupShow">
                <img :src="popupShow.imgSrc" class="w-full" v-if="popupShow.content == 'img'" />
                <embed :src="popupShow.docSrc" width="960px" height="530px" v-if="popupShow.content == 'doc'" />
            </vs-popup>
		</div>
	</div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import quill from 'quill';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {quillEditor} from 'vue-quill-editor';
    const fonts = quill.import('formats/font');
    fonts.whitelist = ['montserrat', 'arial', 'comicsans', 'inconsolata', 'monospace', 'serif'];
    quill.register(fonts, true);

	export default {
		data(){
			return {
                categories: [],
                locals: [],
                parcerias_form:{
                    partner_id: null,
                    partner_category_id: '',
                    category: [],
                    locals: [],
                    expiration_date: null,
                    logo_path: null,
                    logo_full_path: null,
                    visible: true,
                },
                langs: {
                    PT: {
                        partner_translation_id: null,
                        partner: '',
                        description: '',
                        visible: false,
                        files: [],
                    },
                    BR: {
                        partner_translation_id: null,
                        partner: '',
                        description: '',
                        visible: false,
                        files: [],
                    },
                    EN: {
                        partner_translation_id: null,
                        partner: '',
                        description: '',
                        visible: false,
                        files: [],
                    },
                    FR: {
                        partner_translation_id: null,
                        partner: '',
                        description: '',
                        visible: false,
                        files: [],
                    },
                    DE: {
                        partner_translation_id: null,
                        partner: '',
                        description: '',
                        visible: false,
                        files: [],
                    },
                    ES: {
                        partner_translation_id: null,
                        partner: '',
                        description: '',
                        visible: false,
                        files: [],
                    },
                },
                file: [],
                dataHoje: '',
                disabledDatesValidade: {
                    to: null, // Disable all dates up to specific date
                    from: null, // Disable all dates after specific date
                },
                editorOption: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline'],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'indent': '-1'}, {'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{'font': ['montserrat', 'arial', 'comicsans', 'inconsolata', 'monospace', 'serif']}],
                            [{ 'align': [] }],
                            ['link']
                        ]
                    },
                    placeholder: 'Descrição',
                },
                popupShow: {
                    show: false,
                    content: '',
                    title: '',
                    imgSrc: '',
                    docSrc: ''
                },
			}
		},
		methods: {
            /*
             * Vai buscar as categorias
             */
            getCategories() {
                this.$vs.loading();
                this.$api({
                    method: 'get',
                    url: '/myvilagale/parcerias/getCategories',
                    params: {
                        token: localStorage.getItem('usertoken'),
                        language: this.$i18n.locale.toLowerCase(),
                    },
                })
                .then((res) => {
                    this.categories = res.data;
                    this.$vs.loading.close();
                    this.getLocals();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },

            /*
             * Vai buscar os locais
             */
            getLocals() {
                this.$vs.loading();
                this.$api({
                    method: 'get',
                    url: '/myvilagale/parcerias/getLocals',
                    params: {
                        token: localStorage.getItem('usertoken'),
                    },
                })
                .then((res) => {
                    this.locals = res.data;
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },

            /*
             * Vai buscar o parceiro para editar (se for editar)
             */ 
            getPartner(partner_id){
                this.$vs.loading();
                this.$api({
                    method: 'get',
                    url: '/myvilagale/parcerias/getPartner',
                    params: {
                        token: localStorage.getItem('usertoken'),
                        partner_id: partner_id,
                        language: this.$i18n.locale.toUpperCase(),
                    },
                })
                .then((res) => {
                    this.parcerias_form = res.data;
                    this.parcerias_form.expiration_date = res.data.expiration_date == null ? null : new Date(res.data.expiration_date);
                    this.parcerias_form.visible = this.parcerias_form.visible == 1 ? true : false;
                    this.setLang();

                    this.$emit('change_breadcrumb', { title: res.data.translation[0].partner, active: true });
                    this.$vs.loading.close();
                    this.getCategories();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            
            setLang(){
                let translation = this.parcerias_form.translation;
                let language = '';

                for (let i = 0; i < translation.length; i++) {
                    language = translation[i].lang;
                    this.langs[language].partner_translation_id = translation[i].partner_translation_id;
                    this.langs[language].partner = translation[i].partner;
                    this.langs[language].description = translation[i].description;
                    this.langs[language].visible = translation[i].visible == 1 ? true : false;
                    this.langs[language].files = translation[i].file;
                }
            },

            /*
             * Limpar campo de datas
             */ 
            clearDate(input){
                this.parcerias_form[input] = null;
            },

            addFiles(type, country){
                if(type == 'image_file'){
                    if(this.file.length > 0){
                        this.notify('Já chegou ao limite de imagens.', 'red');
                        return;
                    }
                    this.$refs[type].click();

                }else if(type == 'files_file'){
                    if(this.langs[country].files.length > 2){
                        this.notify('Já chegou ao limite de ficheiros.', 'red');
                        return;
                    }
                    this.$refs[type+'_'+country][0].click();
                }
                
            },
            removeFile(type, country, key){
                if(type == 'image_file'){
                    this.file.splice(0, 1);
                    this.parcerias_form.logo_path = null;
                }else if(type == 'files_file'){
                    this.langs[country].files.splice(key, 1);
                }
            },
            handleFileUploads(type, country){
                if(type == 'image_file'){
                    let uploadedFiles = this.$refs['image_file'].files[0];
                    // Tests if the uploaded file has the right extension
                    if (/\.(jpe?g|png)$/i.test(uploadedFiles.name)) {
                        //Adds the uploaded file to the files array
                        this.parcerias_form.logo_path = null;
                        this.parcerias_form.logo_full_path = null;
                        this.file.push(uploadedFiles);
                    } else {
                        this.notify('A imagem tem ser do tipo jpeg, jpg ou png.', 'red');
                    }
                }else if(type == 'files_file'){
                    let uploadedFiles = this.$refs[type+'_'+country][0].files;
                    // Tests if the uploaded file has the right extension
                    if (/\.(pdf)$/i.test(uploadedFiles[0].name)) {
                        //Adds the uploaded file to the files array
                        this.langs[country].files.push(uploadedFiles[0]);
                    } else {
                        this.notify('O ficheiro tem ser um pdf.', 'red');
                    }
                }
            },
            
            /*
             * Submit do formulario
             */
            submitPartner(){
                let to_return = 0;

                if(this.parcerias_form.category.length == 0){
                    this.notify('A Categoria não está selecionada.', 'red');
                    return false;
                }
                
                this.$vs.loading();

                let formData = new FormData();
                let formulario = this.parcerias_form;

                if(this.parcerias_form['expiration_date'] != null){
                    let year = this.parcerias_form['expiration_date'].getFullYear();
                    let month = this.parcerias_form['expiration_date'].getMonth()+1;
                    let day = this.parcerias_form['expiration_date'].getDate();
                    formulario['data_v'] = year+'-'+month+'-'+day;
                }else{
                    formulario['data_v'] = null;
                }
                
                this.buildFormData(formData, {
                    parcerias_form: formulario, 
                    langs: this.langs,
                    file: this.file,
                    user_id: this.$user.id,
                });

                let token = localStorage.getItem('usertoken');

                this.$api.post( '/myvilagale/parcerias/save?token=' + token,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then((res) => {

                    if(this.parcerias_form.partner_id == null){
                        this.notify('Registo criado com sucesso.', 'green');
                        this.$router.push({ name: 'parcerias-form', params: { id: res.data.partner_id }});
                    }else{
                        this.notify('Registo alterado com sucesso.', 'green');
                        //this.$router.go();
                    }
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
                
            },
            /*
             * Mostra popup dos ficheiros
             */
            popupS(content, path, name, lang, key){
                if(content == 'img'){
                    if(this.parcerias_form.logo_path == null){
                        this.popupShow.imgSrc = this.generateImgPath(this.file[0]);
                        this.popupShow.title = this.file[0].name;
                    }else{
                        this.popupShow.imgSrc = path;
                        this.popupShow.title = (/.*\/(.*)/.exec(name)[1]);
                    }
                }else if(content == 'doc'){
                    if(typeof path === 'undefined'){
                        this.popupShow.docSrc = this.generateImgPath(this.langs[lang].files[key]);
                        this.popupShow.title = this.langs[lang].files[key].name;
                    }else{
                        this.popupShow.docSrc = path;
                        this.popupShow.title = name;
                    }
                }
                
                this.popupShow.content = content;
                this.popupShow.show = true;
            },
		},
		created(){
            let d = new Date();
            this.dataHoje = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            this.disabledDatesValidade.to = this.dataHoje;
            /*
             * verifica se estamos em Editar Parceiro
             */
			if(typeof this.$route.params.id !== 'undefined'){
                this.parcerias_form.partner_id = this.$route.params.id;
                this.getPartner(this.parcerias_form.partner_id);
			}else{
                this.getCategories();
                this.$emit('change_breadcrumb', { title: 'Novo', active: true });
            }
        },
        components: {
            Datepicker,
            quillEditor,
        },
        watch: {
            '$i18n.locale': function(new_val, old_val){
                this.getCategories();
            },
            // Fix na visualizacao de docs diferentes em popup
            'popupShow.show': function(valor) {
                if(valor == false){
                    this.popupShow.content = '';
                    this.popupShow.title = '';
                }
            },
        }
	}
</script>

<style scoped>
    @media only screen and (max-width: 370px) {
        .datasLimiteDiv{
            margin-left: -25px !important;
        }
    }
    @media only screen and (max-width: 400px) {
        .mainForm .vdp-datepicker input{
            width: 270px !important;
        }
        .r30{
            right: 0px !important;
            top: -30px;
            left: 240px !important;
        }
    }
    @media only screen and (max-width: 600px) {
        .mainForm .con-tab.vs-tabs--content{
            padding: 10px 0px 10px 0px;
        }
        .pl10p {
            padding-left: 0%;
        }
        .bottomInputs {
            padding: 10px 0px;
        }
        .mainForm .vx-card .vx-card__collapsible-content .vx-card__body {
            padding: 10px !important;
        }
        .titulo{
            padding-left: 10px;
        }
        .questInputs .card-title{
            padding: 1.5rem 5px 1.5rem 5px !important;
        }
        .questInputs .vx-card .vx-card__collapsible-content .vx-card__body{
            padding: 5px !important;
        }
    }
    @media only screen and (max-width: 800px) {
        .datasLimite{
            display: table !important;
            margin-bottom: 0px;
        }
        .r30{
            right: 0px !important;
            top: -30px;
            left: 270px;
        }
    }

    .datasLimiteDiv{
        margin-top: 10px;
    }
    .datasLimite{
        width: 50% !important;
    }
    .bottomInputs {
        padding: 10px 30px;
    }
	.inputNews {
		padding-bottom: 12px;
	}
	.otherInputNews {
		padding-top: 1px;
	}
    .desc_textarea {
        margin-top: 17px;
    }
    .question_text {
        min-height: 150px;
        padding: 1.5rem 1.5rem !important;
    }
    .card-title {
        min-height: 150px;
        padding: 1.5rem 1.5rem !important;
    }
    .giveSpaceEvent {
        min-height: 120px;
    }
    .notSidebySide{
        flex-direction: column;
    }
    .r30{
        right: 0px !important;
        top: -30px;
        left: 270px;
    }
    .w80p {
        width: 80%;
    }
    .w20p {
        width: 20%;
    }
    .mt0 {
        margin-top: 0px;
    }
	.mt15 {
        margin-top: 15px;
    }
	.mt25 {
        margin-top: 25px;
    }
    .mt25i {
        margin-top: 25px !important;
    }
    .mt50 {
        margin-top: 50px;
    }
    .mr10{
        margin-right: 10px;
    }
    .mr15{
        margin-right: 15px;
    }
    .mr25{
        margin-right: 25px;
    }
    .mr40{
        margin-right: 40px;
    }
    .mb10 {
        margin-bottom: 10px;
    }
    .mb15{
        margin-bottom: 15px;
    }
    .mb20{
        margin-bottom: 20px;
    }
    .mb40{
        margin-bottom: 40px;
    }
    .mb80 {
        margin-bottom: 80px;
    }
    .mb25i{
        margin-bottom: 25px !important;
    }
    .ml15 {
        margin-left: 15px;
    }
    .p0020{
        padding: 0 0 2px 0 !important;
    }
    .pl10p {
        padding-left: 10%;
    }
    .pl15 {
        padding-left: 15px;
    }
    .plr20 {
         padding-left: 20px;
         padding-right: 20px;
    }
    .pb15r {
        padding-bottom: 1.5rem !important;
    }
    .pb25 {
        padding-bottom: 25px !important;
    }
    .pr15 {
        padding-right: 15px !important;
    }
    .pr1r {
        padding-right: 1rem !important;
    }
    .fs26 {
        font-size: 26px;
    }
    .vs-component.vs-con-textarea.vs-textarea-primary h4{
        color: #bdbdbd;
    }
    .giveSpaceContent div .con-vs-chip.vs-chip-primary.closable.con-color .text-chip .con-vs-avatar{
        height: 35px;
        width: 35px;
    }
    .vs-notifications h3{
        padding: 0;
    }
    .fix-layer {
        overflow: visible !important;
    }
    .fix-layer .con-slot-tabs{
        overflow: visible !important;
    }

    .mainForm .voltar{
        float: right;
        margin-top: -55px;
    }
    .con-vs-checkbox{
        margin-left: 0 !important;
    }
    .pb60{
        padding-bottom: 60px;
        padding-top: 15px;
    }
    .boxVisible{
        display: flex;
        padding-top: 15px;
        margin-bottom: 15px;
    }

</style>
<style>
    .wPopupShow .vs-popup{
        width: 1000px !important;
    }
</style>